"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCWebUserAgent = exports.USER_AGENT_HEADER_KEY = void 0;
const web_extraction_1 = require("@snapchat/web-extraction");
const web_env_1 = require("@snapchat/web-env");
/** Header under which the user agent would be set. */
/* istanbul ignore next - constant value */
exports.USER_AGENT_HEADER_KEY = "x-snap-client-user-agent";
/** Regex pattern to match for semver strings such as '1.2.3.4', '123.456.789.12345' etc. */
const VERSION_PATTERN = /^(?:\d+\.)?(?:\d+\.)?(?:\d+\.)?(?:\d+)$/;
/**
 * Checks if the passed in version string is of 'SemVer' format and returns the appropriate string if applicable.
 *
 * @param version string that was obtained from the IOS or IBrowser object from the UAParser
 * parsed result.
 * @returns the input as-is if it matches SemVer format or the default '0.0.0' version string.
 */
function getSemVer(version) {
    version = version || "";
    if (!VERSION_PATTERN.test(version)) {
        version = "0.0.0";
    }
    return version;
}
function getFormattedNameAndVersion({ name, version, }) {
    name = (name || "").replace(/\s/g, "").toLowerCase();
    version = getSemVer(version);
    // It's okay if the name is empty, Regex in the useragent libs is smart
    // enough to mark it as an 'Unknown' OS.
    return `${name} ${version}`;
}
/**
 * Utility to create web user-agent strings parse-able by https://github.sc-corp.net/Snapchat/useragent repo
 */
function getCWebUserAgent() {
    const { os, browserName, browserVersion, osVersion } = (0, web_extraction_1.extractUA)();
    let appFlavor;
    if ((0, web_env_1.isRunningOnDevEnv)()) {
        appFlavor = "DEV";
    }
    else if ((0, web_env_1.isRunningOnStaging)()) {
        appFlavor = "STAGING";
    }
    else {
        appFlavor = "PROD";
    }
    return `SnapchatWeb/0.0.0.0 ${appFlavor} (${getFormattedNameAndVersion({
        name: os,
        version: osVersion,
    })}; ${getFormattedNameAndVersion({
        name: browserName,
        version: browserVersion,
    })})`;
}
exports.getCWebUserAgent = getCWebUserAgent;
//# sourceMappingURL=user-agent.js.map